export default __webpack_public_path__ + "static/media/461.c61fd6fd.png";